// extracted by mini-css-extract-plugin
module.exports = {"name":"jgp-vwOJA","amount":"jgp-35jh2","skeleton":"jgp-3nV9C"};